import React from 'react';

import { repeatObjects, verifyConditional } from '../helper';

import Input from './input';
import { getInputLabel } from '../../Edit/helper';
import i18next from 'i18next';
import { GetIcon } from 'datastake-daf/dist/components';

const RepeatableModals = ({
  name = null,
  config = {},
  data = {},
  // allData = {},
  linkingData = {},
  linkingForms = {},
  ajaxOptions = [],
}) => {
  const label = (prop = null) => {
    function getLabel(label) {
      switch (typeof label) {
        case 'string':
          return label;
        case 'object':
          const labelKey = Object.keys(label).find(cond =>
            verifyConditional(cond, data));
          return label[labelKey];
        default:
          return label;
      }
    }
    if (config[prop]) {
      return getLabel(config[prop])
    }
    if (config.sectionLabel) {
      return getLabel(config.sectionLabel);
    }
    if (config.outputLabel) {
      return getLabel(config.outputLabel);

    }
    return getLabel(config.label);
  }

  return verifyConditional(config.showIf ? config.showIf : null, data) ? <div className="group">
    {label('outputLabel') ? (
      <div className="title">
        <h1>{label('outputLabel')}</h1>
      </div>
    ) : null}
    {data[name] && data[name].length ?
      data[name].map((item, index) => (
        <div className="group display" style={{ border: '1px dotted var(--mmt-primary-70)' }}>
          {label() ? (
            <div className="title">
              <h1>{label()} #{index + 1}</h1>
            </div>
          ) : null}
          {repeatObjects(config.inputs, (key) => {
            const modalData = { [name]: { [key]: data[name][index][key] || null } };
            return <div className="group" key={key}>
              <div className="title">
                <h1>{config.inputs[key].outputLabel || getInputLabel(config.inputs[key], item)}</h1>
              </div>
              <Input
                key={key}
                parent={name}
                name={config.inputs[key].dataId || key}
                config={config.inputs[key]}
                data={modalData}
                linkingData={linkingData}
                linkingForms={linkingForms}
                ajaxOptions={ajaxOptions}
                cols={2}>
              </Input>
            </div>
          })}
        </div>
      )
      ) : <span className="text-muted font-italic"><GetIcon icon="WarningOutlined" /> {i18next.t('No Data')}</span>}
  </div> : null;
}

export default RepeatableModals;
